exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad[data-v-068f1f96] {\n  padding: 1em;\n}\n", ""]);

// exports
